<mat-card class="p-0 shadow">
  <div class="row">
    <div class="col-md-4 my-2">
      <button mat-button (click)="back()"> <mat-icon>arrow_back</mat-icon> Back to Shopping Cart</button>
    </div>
    <div class="col-md-4 text-center my-2">
      <mat-card-title class="text-center">Order Summary</mat-card-title>
    </div>
    <div class="col-md-4">

    </div>
  </div>
  <hr class="p-0 mb-4 mt-0">

  <table mat-table [dataSource]="summary">
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef> Item </th>
      <td mat-cell *matCellDef="let line"> {{line.item}} </td>
      <td mat-footer-cell *matFooterCellDef> <span class="texy-primary-total"> Total </span> </td>
    </ng-container>

    <!-- Cost Column -->
    <ng-container matColumnDef="cost">
      <th mat-header-cell *matHeaderCellDef> Cost </th>
      <td mat-cell *matCellDef="let line"> {{line.cost | amount | currency}} </td>
      <td mat-footer-cell *matFooterCellDef> <span class="texy-primary-total"> {{ total | amount | currency}}
        </span></td>
    </ng-container>

    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
  </table>

  <div class="row my-0 px-2 justify-content-center">
    <div class="col-2 col-md-1 text-center ">
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Antu_security-high.svg/512px-Antu_security-high.svg.png"
        alt="" width="80">
    </div>
    <div class="col-10 col-md-7 py-3 ps-5">
      <p><strong>SSL Secure Payment</strong></p>
      <p>Your encryption is protected by 256-bit SSL encryption</p>
    </div>
  </div>
</mat-card>